
const nameList = [
    {
        entityField: "yhqName",
        showField: "优惠券名称",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "yhqDesc",
        showField: "描述",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "limitDay",
        showField: "使用期限（自发放后有效期）",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "state",
        showField: "优惠券状态",
        fieldWeight: 130,
        fieldType: "string",

    },
   {
        entityField: "remark",
        showField: "备注",
        fieldWeight: 130,
        fieldType: "string",

    },


]



const  searchList= [
   

    {
        showField: "优惠券名称",
        entityField: "yhqName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

   
]






export {nameList,searchList}